// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1K_Oy","col":"styles_col__2RjCx"};